import styled from 'styled-components'

import ShimmerBlock from '../../shared/ShimmerBlock'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 0.5em;
`

const ChannelPageShimmer = () => (
  <Wrapper>
    <ShimmerBlock height="20px" width="200px" />
    <ShimmerBlock height="40px" margin="18px 16px" width="40px" />
    <ShimmerBlock height="1px" width="100%" />
    <ShimmerBlock height="40px" margin="18px 16px" width="40px" />
    <ShimmerBlock height="1px" width="100%" />
  </Wrapper>
)

export default ChannelPageShimmer
